module.exports = __webpack_public_path__ + "img/safari.c85af812.svg";